import { route_types, route_names } from ".";

/**
 * Representing an app route checker.
 */
class Checker {
    /**
     * Telling if route is for authenticated users only.
     * @param {import("vue-router").Route} route 
     */
    isProtected(route) {
        return this.isOfType(route, route_types.PROTECTED);
    }

    /**
     * Telling if route is for all users.
     * @param {import("vue-router").Route} route 
     */
    isPublic(route) {
        return this.isOfType(route, route_types.PUBLIC);
    }

    /**
     * Telling if route is for unauthenicated users only.
     * @param {import("vue-router").Route} route 
     */
    isRestricted(route) {
        return this.isOfType(route, route_types.RESTRICTED);
    }

    /**
     * Telling if route is concerning accounts selection page.
     * @param {import("vue-router").Route} route
     * @returns {boolean}
     */
    isAccountSelection(route)
    {
        return route.name === route_names.ACCOUNTS_INDEX;
    }

    /**
     * Telling if given route is having given access type.
     * @param {import("vue-router").Route} route
     * @param {import("./types").RouteAccessTypeInterface} type
     * @private
     */
    isOfType(route, type) {
        const { meta: { access_type = route_types.PUBLIC } = {} } = route;

        return access_type === type;
    }

}

export default Checker;
